import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col, Button, Form, InputGroup } from 'react-bootstrap';
import { MapPin, Briefcase } from 'lucide-react';
import './Home.css';
import homeBg from '../../assets/HomePictures/homeImg1.jpg';
import homeImg2 from '../../assets/HomePictures/homeImg2.jpg';

const Home = () => {
  //For email
  const [emailInput, setEmailInput] = useState('');
  const navigate = useNavigate();

  const categories = [
    "Accounting", "Administrative Assistants", "CDL A and B Drivers",
    "Forklift Operators", "General Labor", "Manufacturing",
    "Order Selectors", "Transportation", "Warehouse Associates", "Welders"
  ];

  //For email
  const handleHelpSubmit = (e) => {
    e.preventDefault();

    // Simple mail validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(emailInput)) {
      alert("Please enter a valid email address.");
      return;
    }

    // Sending user to /contact-us and packing mail in state
    navigate('/contact-us', { state: { prefillEmail: emailInput } });
  };

  //This is for locations
  const [searchTerm, setSearchTerm] = useState('');
  const [locationQuery, setLocationQuery] = useState('');
  const [availableLocations, setAvailableLocations] = useState([]);
  const [filteredSuggestions, setFilteredSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);

  // 1. When page is loaded, we get all jobs and make a list of locations
  useEffect(() => {
    // fetch('http://localhost:5000/api/jobs')
    fetch('/api-portal/jobs')
      .then(res => res.json())
      .then(jobs => {
        const uniqueLocations = [...new Set(jobs.map(job => job.location))];
        setAvailableLocations(uniqueLocations);
      })
      .catch(err => console.error("Error fetching locations:", err));
  }, []);

  // 2. Filtering while the user types
  useEffect(() => {
    if (locationQuery.trim().length > 0) {
      const filtered = availableLocations.filter(loc =>
        loc.toLowerCase().includes(locationQuery.toLowerCase())
      );
      setFilteredSuggestions(filtered);
      setShowSuggestions(true);
    } else {
      setFilteredSuggestions([]);
      setShowSuggestions(false);
    }
  }, [locationQuery, availableLocations]);

  const handleSearch = () => {
    navigate(`/find-jobs?keyword=${searchTerm}&location=${locationQuery}`);
  };

  //This is for the job title

  // State for location
  const [filteredLocSuggestions, setFilteredLocSuggestions] = useState([]);
  const [showLocSuggestions, setShowLocSuggestions] = useState(false);

  // State for job titles
  const [availableTitles, setAvailableTitles] = useState([]);
  const [filteredTitleSuggestions, setFilteredTitleSuggestions] = useState([]);
  const [showTitleSuggestions, setShowTitleSuggestions] = useState(false);

  // 1. Fetch all jobs
  useEffect(() => {
    // fetch('http://localhost:5000/api/jobs')
    fetch('/api-portal/jobs')
      .then(res => res.json())
      .then(jobs => {
        // Unikatne lokacije
        const uniqueLocations = [...new Set(jobs.map(job => job.location))];
        setAvailableLocations(uniqueLocations);

        const uniqueTitles = [...new Set(jobs.map(job => job.title))];
        setAvailableTitles(uniqueTitles);
      })
      .catch(err => console.error("Error fetching data:", err));
  }, []);

  // 2. Filter logic for job title
  useEffect(() => {
    if (searchTerm.trim().length > 0) {
      const filtered = availableTitles.filter(title =>
        title.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredTitleSuggestions(filtered);
      setShowTitleSuggestions(true);
    } else {
      setShowTitleSuggestions(false);
    }
  }, [searchTerm, availableTitles]);

  // 3. Filtering logic for location
  useEffect(() => {
    if (locationQuery.trim().length > 0) {
      const filtered = availableLocations.filter(loc =>
        loc.toLowerCase().includes(locationQuery.toLowerCase())
      );
      setFilteredLocSuggestions(filtered);
      setShowLocSuggestions(true);
    } else {
      setShowLocSuggestions(false);
    }
  }, [locationQuery, availableLocations]);

  // const handleSearch = () => {
  //   navigate(`/find-jobs?keyword=${searchTerm}&location=${locationQuery}`);
  // };

  return (
    <div className="home-page">
      {/* /* Section 1: --------------------------------------------------------------------------*/}
      <section
        className="hero-section"
        style={{ backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.40), rgba(0, 0, 0, 0)), url(${homeBg})` }}
      >
        <Container>
          <div className="hero-content-wrapper">

            <h2 className="hero-title">
              At INFINITI, we understand the importance <br />
              of a perfect fit between employer and employee.
            </h2>

            <div className="modern-search-bar shadow-lg">
              <div className="search-input-group">

                {/* First Input: Job title search */}
                <div className="search-input-wrapper" style={{ position: 'relative', flex: 1 }}>
                  <input
                    type="text"
                    className="main-input w-100"
                    placeholder="Job title or keywords"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    onFocus={() => searchTerm.length > 0 && setShowTitleSuggestions(true)}
                    onBlur={() => setTimeout(() => setShowTitleSuggestions(false), 200)}
                  />

                  {showTitleSuggestions && filteredTitleSuggestions.length > 0 && (
                    <div className="search-suggestions-dropdown shadow-lg animate-in">
                      {filteredTitleSuggestions.map((title, index) => (
                        <div
                          key={index}
                          className="suggestion-item"
                          onClick={() => {
                            setSearchTerm(title);
                            setShowTitleSuggestions(false);
                          }}
                        >
                          <Briefcase size={14} className="me-2 text-primary" />
                          {title}
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                <div className="divider"></div>

                {/* Second input: Location Search */}
                <div className="location-input-wrapper" style={{ position: 'relative', flex: 1 }}>
                  <input
                    type="text"
                    className="main-input w-100"
                    placeholder="All locations"
                    value={locationQuery}
                    onChange={(e) => setLocationQuery(e.target.value)}
                    onFocus={() => locationQuery.length > 0 && setShowLocSuggestions(true)}
                    onBlur={() => setTimeout(() => setShowLocSuggestions(false), 200)}
                  />

                  {showLocSuggestions && filteredLocSuggestions.length > 0 && (
                    <div className="search-suggestions-dropdown shadow-lg animate-in">
                      {filteredLocSuggestions.map((loc, index) => (
                        <div
                          key={index}
                          className="suggestion-item"
                          onClick={() => {
                            setLocationQuery(loc);
                            setShowLocSuggestions(false);
                          }}
                        >
                          <MapPin size={14} className="me-2 text-primary" />
                          {loc}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Find Job Dugme */}
            <div className="hero-action-row">
              <Button className="btn-find-job" onClick={handleSearch}>
                Find a job
              </Button>
            </div>
          </div>
        </Container>
      </section>

      {/* Section 1: --------------------------------------------------------------------------*/}

      {/* Section 2: --------------------------------------------------------------------------*/}

      <section className="categories-section py-5">
        <Container>

          {/* Title and subtitle */}
          <div className="text-center mb-5 categories-header">
            <h2 className="section-title">Find your perfect job</h2>
            <p className="section-subtitle mx-auto">
              What kind of job are you looking for? If you don't see a category you're interested in,
              use our easy search feature up top.
            </p>
          </div>

          <Row className="g-3 justify-content-center">
            {categories.map((category, index) => (
              <Col key={index} xs={6} md={4} className="col-lg-2-4">
                <div className="category-card shadow-sm text-center">
                  <div className="card-content">
                    <span className="category-name">{category}</span>
                  </div>
                </div>
              </Col>
            ))}
          </Row>

        </Container>
      </section>
      {/* Section 2: --------------------------------------------------------------------------*/}


      {/* Section 3: Impact Banner ------------------------------------------------------------*/}
      <section className="impact-section" style={{ backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.40), rgba(0, 0, 0, 0)), url(${homeImg2})` }}>
        <Container className="h-100 d-flex align-items-center">
          <Row className="w-100">
            <Col lg={7} className="text-white text-start reveal-text">

              {/* First part of the text */}
              <div className="impact-main-content">
                <h2 className="display-4 fw-bold mb-3">Let's get to work.</h2>
                <p className="impact-text">
                  Finding a new job isn't fun. Most of the time it's incredibly stressful.
                  We've created a process that makes it easy for you to find local jobs
                  and get your resumes in front of the decision makers.
                </p>
              </div>

              {/* Difference of 50px */}
              <div style={{ marginTop: '90px' }}></div>

              {/* Second text (We are Central Florida) */}
              <div className="impact-trust-content">
                <h3 className="trust-title-on-image">We are Central Florida</h3>
                <p className="trust-subtitle-on-image">
                  We've worked with some of Central Florida's biggest companies <br />
                  and would love to help you with your career path.
                </p>
              </div>

            </Col>
          </Row>
        </Container>
      </section>
      {/* Section 3: Impact banner ------------------------------------------------------------*/}

      {/* Section 4: Contact ---------------------------------------------------------------*/}
      <section className="help-section py-5">
        <Container>
          <div className="help-content text-center py-4">
            <h2 className="help-title mb-3">Still Need Help?</h2>
            <p className="help-subtitle mb-4">Let us know about your issue...</p>

            <div className="help-form-wrapper mx-auto">
              <InputGroup size="lg" className="shadow-sm">
                <Form.Control
                  placeholder="Enter valid email address"
                  value={emailInput}
                  onChange={(e) => setEmailInput(e.target.value)}
                  className="help-input border-0"
                />
                <Button
                  className="btn-submit-help text-uppercase fw-bold px-4"
                  onClick={handleHelpSubmit}
                >
                  Submit
                </Button>
              </InputGroup>
            </div>
          </div>
        </Container>
      </section>
    </div>
  );
};

export default Home;